var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.058,
    height: 28.844,
    viewBox: "0 0 33.058 28.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3a7aff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -32.631)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(11 32.631)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(24 36.631)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(2 36.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.664,241.528c-1.4-1.145-2.664-.994-4.28-.994A4.376,4.376,0,0,0,0,244.892v7.051a1.9,1.9,0,0,0,1.9,1.892c4.521,0,3.977.082,3.977-.195C5.875,248.644,5.284,244.98,8.664,241.528Z",
    transform: "translate(0 -194.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.491,239.926c-2.823-.235-5.277,0-7.393,1.75-3.542,2.837-2.86,6.657-2.86,11.33a2.265,2.265,0,0,0,2.261,2.261c13.629,0,14.171.44,14.979-1.35.265-.605.192-.413.192-6.2C137.67,243.115,133.688,239.926,130.491,239.926Z",
    transform: "translate(-112.425 -193.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.09,240.536c-1.625,0-2.884-.15-4.28.994,3.355,3.426,2.789,6.84,2.789,12.112,0,.279-.452.195,3.909.195a1.965,1.965,0,0,0,1.967-1.959v-6.984A4.376,4.376,0,0,0,382.09,240.536Z",
    transform: "translate(-353.416 -194.475)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a7f650fd7c665a3b15f21b99cf0ec577.svg";
export { ForwardRef as ReactComponent };